exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "register-container{width:50%;height:100%;float:left}.register{font:10px sans-serif;height:100%;overflow:hidden}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./css/register.css
// module id = 102
// module chunks = 0